// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .qr-code {
  padding: 50px 20px 20px 20px;
}
.popup .qr-code h2 {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .qr-code figure {
  background: #f5f5f5;
  border-radius: 5px;
  margin: 6% 0;
}
.popup .qr-code figure img {
  width: 100%;
  height: auto;
}
.popup .qr-code figure canvas {
  width: 100% !important;
  height: auto !important;
}
.popup .qr-code .share-button {
  background-color: #caa36c;
  border-radius: 5px;
  margin-top: 8%;
}
.popup .qr-code .share-button a {
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 0 7%;
  display: block;
}
.popup .qr-code .share-button a span {
  font: 1.7em/1 vigaregular;
  color: white;
}
.popup .qr-code .print-button {
  margin-top: 8%;
}
.popup .qr-code .print-button a {
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 7% 0 7%;
  display: block;
}
.popup .qr-code .print-button a {
  border: 2px solid #caa36c;
}
.popup .qr-code .print-button span {
  font: 1.9em/1 vigaregular;
  color: #caa36c;
}

@media (min-width: 420px) {
  .share-button {
    display: none;
  }
}
@media print {
  .app * {
    display: none;
  }
  body {
    background-color: #fff;
  }
  body .app {
    background: none;
  }
  body .app .popup {
    background: none;
    display: block;
  }
  body .app .popup .overflow {
    display: block;
  }
  body .app .popup .overflow .box {
    display: block;
  }
  body .app .popup .overflow .box .qr-code {
    display: block;
  }
  body .app .popup .overflow .box .qr-code figure {
    background: none;
    display: block;
  }
  body .app .popup .overflow .box .qr-code figure img {
    display: block;
  }
  body .app .popup .overflow .box .qr-code figure canvas {
    display: block;
  }
  body .app .popup .overflow .box .close {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/QRCodeContent.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;AAAR;AAEQ;EACI,uBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,mBAAA;EACA,kBAAA;EACA,YAAA;AADZ;AAGY;EACI,WAAA;EACA,YAAA;AADhB;AAIY;EACI,sBAAA;EACA,uBAAA;AAFhB;AAMQ;EACI,yBAAA;EACA,kBAAA;EACA,cAAA;AAJZ;AAKY;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAHhB;AAIgB;EACI,yBAAA;EACA,YAAA;AAFpB;AAOQ;EACI,cAAA;AALZ;AAMY;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAJhB;AAOY;EACI,yBAAA;AALhB;AAQY;EACI,yBAAA;EACA,cAAA;AANhB;;AAYA;EACI;IACI,aAAA;EATN;AACF;AAYA;EAEQ;IACI,aAAA;EAXV;EAeE;IACI,sBAAA;EAbN;EAeM;IACI,gBAAA;EAbV;EAeU;IACI,gBAAA;IACA,cAAA;EAbd;EAcc;IACI,cAAA;EAZlB;EAakB;IACI,cAAA;EAXtB;EAasB;IACI,cAAA;EAX1B;EAa0B;IACI,gBAAA;IACA,cAAA;EAX9B;EAa8B;IACI,cAAA;EAXlC;EAc8B;IACI,cAAA;EAZlC;EAiBsB;IACI,aAAA;EAf1B;AACF","sourcesContent":[".popup {\n    .qr-code {\n        padding: 50px 20px 20px 20px;\n\n        h2 {\n            font: 2em/1 vigaregular;\n            color: #5c5c5c;\n        }\n\n        figure {\n            background: #f5f5f5;\n            border-radius: 5px;\n            margin: 6% 0;\n\n            img {\n                width: 100%;\n                height: auto;\n            }\n\n            canvas {\n                width: 100% !important;\n                height: auto !important;\n            }\n        }\n\n        .share-button {\n            background-color: #caa36c;\n            border-radius: 5px;\n            margin-top: 8%;\n            a {\n                text-decoration: none;\n                text-align: center;\n                border-radius: 5px;\n                padding: 7% 0 7%;\n                display: block;\n                span {\n                    font: 1.7em/1 vigaregular;\n                    color: white;\n                }\n            }\n        }\n\n        .print-button {\n            margin-top: 8%;\n            a {\n                text-decoration: none;\n                text-align: center;\n                border-radius: 5px;\n                padding: 7% 0 7%;\n                display: block;\n            }\n\n            a {\n                border: 2px solid #caa36c;\n            }\n\n            span {\n                font: 1.9em/1 vigaregular;\n                color: #caa36c;\n            }\n        }\n    }\n}\n\n@media (min-width: 420px) {\n    .share-button {\n        display: none; \n    }\n}\n\n@media print {\n    .app {\n        * {\n            display: none;\n        }\n    }\n\n    body {\n        background-color: #fff;\n\n        .app {\n            background: none;\n\n            .popup {\n                background: none;\n                display: block;\n                .overflow{\n                    display: block;\n                    .box {\n                        display: block;\n\n                        .qr-code {\n                            display: block;\n\n                            figure {\n                                background: none;\n                                display: block;\n\n                                img {\n                                    display: block;\n                                }\n\n                                canvas {\n                                    display: block;\n                                }\n                            }\n                        }\n\n                        .close {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
